export default "__VITE_ASSET__a1368fd1__"